import { useMemo } from "react";
import { barRuns, encodeBarcode } from "@/lib/barcode";

function Code128({ code }) {
  const enc = useMemo(() => encodeBarcode(code), [code]);
  if (!enc) return null;
  const total = enc.quiet[0] + enc.bits.length + enc.quiet[1];
  return (
    <div className="r-center" data-testid="receipt-barcode" data-code={code}>
      <svg viewBox={`0 0 ${total} 30`} style={{ width: "100%", height: "14mm" }} preserveAspectRatio="none" shapeRendering="crispEdges" role="img" aria-label={`Code 128 ${code}`}>
        {barRuns(enc.bits, enc.quiet[0]).map(([x, w]) => <rect key={x} x={x} y={0} width={w} height={30} fill="#000" />)}
      </svg>
      <div className="r-tiny">{code}</div>
    </div>
  );
}

export function Receipt({ model }) {
  return (
    <div className={`receipt receipt-${model.width}`} data-testid="receipt">
      <div className="r-center r-strong r-big" data-testid="receipt-business-name">{model.businessName}</div>
      {model.header.map((h, i) => (
        <div key={i} className="r-center">{h}</div>
      ))}
      {model.branch && <div className="r-center" data-testid="receipt-branch-name">{model.branch}</div>}
      {model.branchAddress && <div className="r-center" data-testid="receipt-branch-address">{model.branchAddress}</div>}
      {model.branchPhone && <div className="r-center" data-testid="receipt-branch-phone">{model.branchPhone}</div>}
      {model.taxNumber && <div className="r-center" data-testid="receipt-tax-number">{model.taxNumber}</div>}
      {model.title && <div className="r-center r-strong r-big" data-testid="receipt-title">{model.title}</div>}
      <div className="r-rule" />
      <div className="r-row"><span>{model.codeLabel || "Receipt"}</span><span data-testid="receipt-number">{model.receiptCode}</span></div>
      <div className="r-row"><span>{model.date}</span><span>{model.time}</span></div>
      {(model.notes || []).map((n, i) => <div key={`n${i}`} style={{ whiteSpace: "normal", overflowWrap: "anywhere" }} data-testid={`receipt-note-${i}`}>{n}</div>)}
      <div className="r-rule" />
      {model.items.map((it, i) => (
        <div key={i} className="r-item" data-testid={`receipt-item-${i}`}>
          <div className="r-name">{it.name}</div>
          <div className="r-row"><span>{it.qtyLine}</span><span>{it.amount}</span></div>
          {it.discount && <div className="r-row"><span>  Discount</span><span>{it.discount}</span></div>}
          {it.batches.map((b, j) => (
            <div key={j} className="r-batch">{b}</div>
          ))}
        </div>
      ))}
      <div className="r-rule" />
      {model.totals.map((t, i) => (
        <div key={i} className={`r-row ${t.strong ? "r-strong r-total" : ""}`} data-testid={t.strong ? "receipt-total" : undefined}>
          <span>{t.label}</span><span>{t.value}</span>
        </div>
      ))}
      <div className="r-rule" />
      {model.payment.map((p, i) => (
        <div key={i} className="r-row" data-testid={`receipt-payment-${p.label.toLowerCase().replace(/\s/g, "-")}`}>
          <span>{p.label}</span><span>{p.value}</span>
        </div>
      ))}
      {model.barcode && <><div className="r-rule" /><Code128 code={model.barcode} /></>}
      {model.footer.length > 0 && <div className="r-rule" />}
      {model.footer.map((f, i) => (
        <div key={i} className="r-center">{f}</div>
      ))}
      <div className="r-center r-tiny">Powered by Smart-in Retail</div>
    </div>
  );
}
